import { Pipe, PipeTransform } from "@angular/core";
import { isDefined } from "@recursyve/nice-ts-utils";
import { sanitizeDirectusObject } from "../../../../../common/utils/sanitize-directus-object";
import { ItemsAdPackages } from "../../../../api/packbo/models/items-ad-packages";
import { ItemsNavigationItems } from "../../../../api/packbo/models/items-navigation-items";

@Pipe({
    name: "sanitizeAdPackage"
})
export class SanitizeAdPackagePipe implements PipeTransform {
    public transform(adPackage: ItemsAdPackages): ItemsNavigationItems | null {
        const sanitize = sanitizeDirectusObject(adPackage.link);

        if (isDefined(sanitize)) {
            return sanitize;
        }

        return null;
    }
}
